import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "/api"            // same origin on App Engine
      : "http://localhost:3001/api",
  withCredentials: true,
});

// Attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth failures
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest =
      error.config?.url?.includes('/auth/google-signin');
    const status = error.response?.status;
    const msg = error.response?.data?.message || '';
    const isJwtAuthFailure =
      status === 401 ||
      (status === 403 &&
        (msg.includes('Token') || msg.includes('Access Denied')));

    if (isJwtAuthFailure) {
      if (!isLoginRequest && window.location.pathname !== '/signin') {
        localStorage.clear();
        window.location.href = '/signin';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
